import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import Checkbox from "components/Checkbox";
import { FormField } from "components/Form";

export default function ConsentStep() {
  const { t } = useTranslation();

  const { control } = useFormContext();

  return (
    <>
      <div className="gap-4 flex flex-col">
        <div className="font-semibold">{t("settings.companySettingsDialog.consent")}</div>
        <div className="text-general-gray-700 flex flex-col gap-2.5">
          {t("settings.companySettingsDialog.consentDescription")}
          <ol className="flex flex-col gap-1.5">
            <li>{t("settings.companySettingsDialog.consentPurpose1")}</li>
            <li>{t("settings.companySettingsDialog.consentPurpose2")}</li>
            <li>{t("settings.companySettingsDialog.consentPurpose3")}</li>
            <li>{t("settings.companySettingsDialog.consentPurpose4")}</li>
          </ol>
        </div>

        <div className="text-general-gray-700 flex flex-col gap-2.5">
          <div className="font-semibold">{t("settings.companySettingsDialog.consentConfirmation")}</div>

          <ol className="flex flex-col gap-1.5">
            <li>{t("settings.companySettingsDialog.consentConfirmationPurpose1")}</li>
            <li>{t("settings.companySettingsDialog.consentConfirmationPurpose2")}</li>
            <li>{t("settings.companySettingsDialog.consentConfirmationPurpose3")}</li>
          </ol>
        </div>
      </div>
      <FormField
        control={control}
        name="confirmation"
        render={({ field }) => (
          <Checkbox
            id={field.name}
            checked={field.value}
            onCheckedChange={field.onChange}
            label={t("settings.companySettingsDialog.consentCheckboxLabel")}
          />
        )}
      />
    </>
  );
}
